import { useState } from "react";
import axios from "axios";
import { Lock, RefreshCw } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Admin() {
  const [key, setKey] = useState("");
  const [enquiries, setEnquiries] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await axios.get(`${API}/enquiries`, { params: { key } });
      setEnquiries(res.data);
    } catch (e) {
      setError("Incorrect passcode or server error.");
      setEnquiries(null);
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-espresso text-cream px-5 py-16">
      <div className="max-w-4xl mx-auto">
        <h1 className="font-serif text-4xl" data-testid="admin-title">Momay Enquiries</h1>
        <p className="text-cream/50 text-sm mt-2 font-light">Internal view — catering enquiries from the website.</p>

        <div className="mt-8 flex gap-3">
          <div className="relative flex-1">
            <Lock size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-gold" />
            <input
              data-testid="admin-passcode-input"
              type="password"
              value={key}
              onChange={(e) => setKey(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && load()}
              placeholder="Admin passcode"
              className="w-full bg-espresso-light border gold-hairline pl-10 pr-4 py-3 outline-none focus:border-gold text-cream placeholder:text-cream/30"
            />
          </div>
          <button data-testid="admin-load-btn" onClick={load} disabled={loading} className="bg-gold text-espresso px-6 py-3 text-xs tracking-[0.25em] uppercase font-medium hover:bg-cream transition-colors disabled:opacity-50 flex items-center gap-2">
            <RefreshCw size={14} className={loading ? "animate-spin" : ""} /> Load
          </button>
        </div>

        {error && <p data-testid="admin-error" className="mt-4 text-red-300 text-sm">{error}</p>}

        {enquiries && (
          <div className="mt-10 space-y-4" data-testid="admin-enquiries-list">
            {enquiries.length === 0 && <p className="text-cream/50 font-light">No enquiries yet.</p>}
            {enquiries.map((e) => (
              <div key={e.id} data-testid={`admin-enquiry-${e.id}`} className="border gold-hairline p-5 bg-espresso-light/50">
                <div className="flex flex-wrap items-baseline justify-between gap-2">
                  <span className="font-serif text-xl text-gold">{e.name}</span>
                  <span className="text-[10px] tracking-[0.2em] uppercase text-cream/40">{new Date(e.created_at).toLocaleString("en-IN")} • {e.source}</span>
                </div>
                <p className="text-sm text-cream/70 mt-1">{e.phone || "— no phone —"} • {e.event_type}{e.event_date ? ` • ${e.event_date}` : ""}{e.event_location ? ` • ${e.event_location}` : ""}</p>
                <p className="text-sm text-cream/50 mt-1 font-light">
                  {e.guests ? `Guests: ${e.guests} • ` : ""}{e.cuisine ? `Cuisine: ${e.cuisine} • ` : ""}{e.budget ? `Budget: ${e.budget}` : ""}
                </p>
                {e.message && <p className="text-sm text-cream/60 mt-2 font-light italic">“{e.message}”</p>}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
